import { createFileRoute } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';

import { ConsolidatedPerformance } from '@/components/performance/consolidated/consolidated-performance';
import { withOrgReset } from '@/components/glitch-ui/with-org-reset';

// Consolidated Performance surface (#5971). New test-mode-gated path; the existing
// /performance and /performance-v2 routes are untouched until CP-13 retires them.
export const Route = createFileRoute('/_authenticated/_layout/performance-consolidated/')({
  component: withOrgReset(ConsolidatedPerformance),
  staticData: {
    title: 'Performance (Unified)',
    icon: BarChart3,
  },
});
